<template>
    <div class="join">
        <div class="join__container">
            <h2 class="join__title">Начни сегодня</h2>
            <div class="join__filters" v-if="!isEmpty">
                <ModelCheckbox class="filter__checkbox" v-model="isProjects" label="Проекты" />
                <ModelCheckbox class="filter__checkbox" v-model="isEvents" label="Обучение" />
                <ModelCheckbox class="filter__checkbox" v-model="isInternships" label="Стажировки" />
            </div>
            <div class="join__cards" v-if="!isEmpty">
                <template v-if="isProjects">
                    <CardJoinProject v-for="project in filteredProjects" :key="project.id" :project="project" />
                </template>
                <template v-if="isEvents">
                    <CardJoinCourse v-for="event in filteredEvents" :key="event.id" :event="event" />
                </template>
                <template v-if="isInternships">
                    <CardJoinInternship
                        v-for="internship in filteredInternships"
                        :key="internship.id"
                        :internship="internship"
                    />
                </template>
            </div>
            <div class="join__empty-message" v-else>
                <div class="join__empty-message-text">Добавляй новые возможности на вкладке «Рекомендации»</div>
                <button class="join__empty-message-button" @click="goToRecommendations">Добавить</button>
            </div>
        </div>
    </div>
</template>

<script>
import CardJoinProject from './CardJoinProject.vue';
import CardJoinInternship from './CardJoinInternship.vue';
import CardJoinCourse from './CardJoinCourse.vue';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import { mapGetters } from 'vuex';

export default {
    name: 'Join',
    components: {
        CardJoinProject,
        CardJoinInternship,
        CardJoinCourse,
        ModelCheckbox,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isProjects: true,
            isEvents: true,
            isInternships: true,
        };
    },
    computed: {
        ...mapGetters('track', ['favoriteProjects', 'favoriteEvents', 'favoriteInternships']),
        filteredProjects() {
            // отфильтровать проекты favoriteProjects за исключением тех, которые уже есть в items
            const activeProjects = this.items.filter((project) => project.type === 'project');
            const favoriteProjects = this.favoriteProjects.filter((favorite) => favorite.registration_is_open === true);
            return favoriteProjects.filter((project) => !activeProjects.find((item) => item.id === project.projectId));
        },
        filteredEvents() {
            // отфильтровать события favoriteEvents за исключением тех, которые уже есть в items
            return this.favoriteEvents.filter(
                (event) => !this.items.some((item) => item.type === 'event' && item.id === event.id)
            );
        },
        filteredInternships() {
            // отфильтровать стажировки favoriteInternships за исключением тех, которые уже есть в items
            return this.favoriteInternships.filter(
                (internship) =>
                    !this.items.some((item) => item.type === 'internship' && item.id === internship.projectId)
            );
        },
        isEmpty() {
            return (
                this.filteredProjects.length === 0 &&
                this.filteredEvents.length === 0 &&
                this.filteredInternships.length === 0
            );
        },
    },
    methods: {
        goToRecommendations() {
            this.$store.dispatch('track/setActiveTab', 'recommendations');
        },
    },
    mounted() {
        this.$store.dispatch('track/fetchFavorites');
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.join {
    width: 100%;
    font-family: $font-montserrat;

    * {
        font-family: inherit;
    }

    @include on-desktop {
        border-radius: urem(16);
        padding: urem(24) 0;
        background: #f5f9fd;
        width: urem(415);
        padding-right: urem(16);
        padding-bottom: urem(24);
    }

    &__title {
        display: none;

        @include on-desktop {
            display: block;
            padding: 0 urem(24);
            font-size: urem(20);
            font-weight: 600;
            line-height: urem(34);
            color: #2a2626;
            margin-top: 0;
            margin-bottom: urem(13);
        }
    }

    &__cards {
        display: flex;
        flex-direction: column;
        gap: urem(16);
        background: none;

        @include on-desktop {
            overflow-y: auto;
            overflow-x: visible;
            height: urem(514);
            padding: 0 urem(24);
            padding-top: urem(16);
            padding-right: urem(8);
            padding-bottom: urem(16);
            margin-top: urem(-10);

            /* Стиль самого скроллбара */
            &::-webkit-scrollbar {
                width: rem(6); /* Ширина скроллбара */
            }
            /* Стиль трека (фона) скроллбара */
            &::-webkit-scrollbar-track {
                background: transparent; /* Цвет трека */
            }
            /* Стиль ползунка (то, что движется) */
            &::-webkit-scrollbar-thumb {
                background-color: #a2b1d5; /* Цвет ползунка */
                border-radius: rem(8); /* Скругление углов */
                border: none;
            }
            /* Стиль при наведении */
            &::-webkit-scrollbar-thumb:hover {
                background-color: #ccccd7; /* Цвет при наведении */
            }
        }
    }

    &__filters {
        display: flex;
        align-items: center;
        gap: urem(14);
        padding: urem(8) 0;

        @include on-desktop {
            padding: 0 urem(24);
            gap: urem(24);
        }
    }

    &__empty-message {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: urem(16);
        width: 100%;

        @include on-desktop {
            margin-top: urem(24);
            margin-left: urem(24);
        }
    }

    &__empty-message-text {
        font-size: urem(16);
        font-weight: 400;
        line-height: urem(24);
        color: #2a2626;
        padding: urem(12) urem(20);
        background: #f7f9fc;
        border-radius: urem(10);
        margin-bottom: urem(12);
        margin-top: urem(12);
        width: 100%;

        @include on-desktop {
            margin-top: 0;
            background: #ffffff;
            width: 92%;
        }
    }

    &__empty-message-button {
        width: 100%;
        padding: 0;
        height: urem(42);
        background: none;
        color: #4663ab;
        border: urem(1) solid #4663ab;
        border-radius: urem(10);
        font-size: urem(14);
        font-weight: 600;
        line-height: urem(42);
        margin-right: 0;
        cursor: pointer;

        @include on-desktop {
            width: 92%;
            margin-right: urem(24);
        }
    }
}
</style>
